{
  "configuration": {
    "name_label": "Name"
  },
  "widgets": {
    "actions": {
      "resize": "Resize",
      "config": "Edit",
      "move": "Move",
      "remove": "Delete"
    },
    "time_period": "Time Period",
    "choose_period": "Choose period...",
    "live": "Live",
    "last_day": "Yesterday",
    "last_week": "Last Week",
    "maximum_widget_number_reached": "Sorry. You can't add more widgets.",
    "open_monitor_page": "Open Monitor",
    "chart_widget_min_selected": "must have at least one data point selected"
  },
  "heatmap_widget": {
    "title": "Parameter Widget",
    "config_dialog_title": "Parameter Widget"
  },
  "blocks_widget": {
    "empty_data_point": "no data point to view",
    "title": "Blocks Widget",
    "config_dialog_title": "Blocks Widget"
  },
  "node_widget": {
    "empty_data_point": "no data point to view",
    "title": "Device Widget",
    "config_dialog_title": "Device Widget",
    "last_time_reported": "Last Time Reported\n%{value}"
  },
  "text_widget": {
    "title": "Edit Text",
    "config_dialog_title": "Edit Text"
  },
  "chart_widget": {
    "title": "Chart Widget",
    "config_dialog_title": "Chart Widget",
    "group_ungroup_title": "Group/Ungroup by unit",
    "ordinal_title": "Show/Hide data gaps",
    "reset_selected_range": "Reset Selected Range",
    "group_axis": "Group Axis"
  },
  "connectivity_widget": {
    "title": "Connectivity Widget",
    "config_dialog_title": "Connectivity Widget"
  },
  "distribution_widget": {
    "title": "Distribution Widget",
    "config_dialog_title": "Distribution Widget",
    "default_name": "Distribution of %{parameter}",
    "interval_minutes": "%{n} min",
    "interval_hours": "%{n}h",
    "too_many_readings": "Too many readings to display. Pick an aggregation interval or a shorter time range.",
    "stats": {
      "min": "Min",
      "avg": "Avg",
      "max": "Max"
    },
    "errors": {
      "parameter_required": "Select a parameter",
      "one_parameter": "Select the same parameter on every device"
    }
  },
  "compare_devices_widget": {
    "title": "Compare Devices Widget",
    "config_dialog_title": "Compare Devices Widget",
    "group_ungroup_title": "Group/Ungroup by unit",
    "reset_selected_range": "Reset Selected Range",
    "group_axis": "Group Axis"
  },
  "map_widget": {
    "title": "Map Widget",
    "config_dialog_title": "Map Widget",
    "no_location": "Location NOT available",
    "air_quality": "Air Quality"
  },
  "wind_rose_widget": {
    "title": "Wind Rose Widget",
    "config_dialog_title": "Wind Rose Widget",
    "wind_speed_label": "Wind Speed",
    "wind_direction_label": "Wind Direction"
  },
  "table_widget": {
    "title": "Table Widget",
    "config_dialog_title": "Table Widget"
  },
  "thiamis_widget": {
    "title": "Thiamis Device",
    "config_dialog_title": "Thiamis Device"
  },
  "info_widget": {
    "title": "Node Info Widget",
    "config_dialog_title": "Node Info Widget"
  },
  "sensor_widget": {
    "config_dialog_title_new": "Add Sensor"
  },
  "modules_widget": {
    "title": "Expansion Module %{name}",
    "config_dialog_title": "Expansion Module %{name}"
  },
  "total_devices_online_pie_chart_widget": {
    "title": "Total Devices"
  },
  "total_devices_online_column_chart_widget": {
    "title": "Total Devices By Type"
  },
  "devices_online_chart_widget": {
    "title": "Devices Online"
  },
  "recent_alerts_widget": {
    "title": "Recent Alerts"
  },
  "recent_measurements_widget": {
    "local_time": "Device Local Time",
    "local_time_title": "Device Local Time<br /><small>%{timezone}</small>",
    "deselect_all_data_points": "Deselect all data points"
  },
  "heatmap_legend": {
    "excellent": "Excellent",
    "good": "Good",
    "satisfactory": "Satisfactory",
    "moderate": "Moderate",
    "poor": "Poor",
    "veryPoor": "Very Poor",
    "offline": "Offline",
    "online": "Online"
  }
}
